import React from 'react';
import { Typography } from "@mui/material";
import { useEnums } from '../hooks/useEnums';

const ProteinPreference = ({ selectedProteins = [], setSelectedProteins, title }) => {
  const enums = useEnums();

  // Make sure we have an array of protein values and provide component instance identity
  const safeSelectedProteins = Array.isArray(selectedProteins) ? selectedProteins : [];

  // Debug info
  console.log(`ProteinPreference (${title}) received selectedProteins:`, safeSelectedProteins);

  const toggleProtein = (proteinValue) => {
    if (!setSelectedProteins) {
      console.log(`No setSelectedProteins function provided to ${title}`);
      return;
    }

    // Log the current state and the change being made
    console.log(`ProteinPreference (${title}) toggling ${proteinValue}`);
    console.log(`Current selection:`, safeSelectedProteins);

    // Calculate new state
    const newSelection = safeSelectedProteins.includes(proteinValue)
      ? safeSelectedProteins.filter(value => value !== proteinValue)
      : [...safeSelectedProteins, proteinValue];

    console.log(`New selection will be:`, newSelection);

    // Update state
    setSelectedProteins(newSelection);
  };

  return (
    <div className="protein-preference-container">
             <Typography variant="h6" gutterBottom className="section-title">
         {title}
       </Typography>
      {Object.entries(enums.proteinTypes || {}).map(([group, subtypes]) => (
        <div key={group} className="protein-group">
          <Typography variant="subtitle2" sx={{ mt: 1, mb: 0.5, fontSize: '0.85rem', color: '#666' }}>
            {group}
          </Typography>
          <div className="protein-selection">
            {[...subtypes].sort().map((protein) => {
              const isSelected = safeSelectedProteins.includes(protein);

              return (
                <div
                  key={`${title}-${protein}`}
                  className={`protein-option ${isSelected ? "selected" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleProtein(protein);
                  }}
                >
                  <div className="protein-container">
                    <div className="protein-label-container">
                      <span className="protein-label">
                        {protein}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProteinPreference;